import type {SideEffectCreator, Listener} from './types';

export const withSideEffect: SideEffectCreator =
  // @ts-expect-error - TS2322 - Type '(callback: Listener) => (event: Event) => boolean | undefined' is not assignable to type '(callback: Listener) => Listener'.
  (sideEffect) => (callback: Listener) => (event: Event) => {
    sideEffect(event);
    return callback(event);
  };

export const preventDefault: (callback: Listener) => Listener = withSideEffect(
  (event) =>
    typeof event.preventDefault === 'function' && event.preventDefault()
);
export const stopPropagation: (callback: Listener) => Listener = withSideEffect(
  (event) =>
    typeof event.stopPropagation === 'function' && event.stopPropagation()
);
